var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock-svgrepo-com 1",
    clipPath: "url(#clip0_19479_3267)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_509_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_510_",
    d: "M3.34841 17H13.6514C14.0782 17 14.4242 16.654 14.4242 16.2273V7.4697C14.4242 7.04295 14.0782 6.69697 13.6514 6.69697H12.8787V4.37879C12.8787 1.96432 10.9144 0 8.49993 0C6.08546 0 4.12114 1.96432 4.12114 4.37879V6.69697H3.34841C2.92166 6.69697 2.57568 7.04295 2.57568 7.4697V16.2273C2.57568 16.654 2.92166 17 3.34841 17ZM9.27265 12.1053V13.1364C9.27265 13.5631 8.92668 13.9091 8.49993 13.9091C8.07317 13.9091 7.7272 13.5631 7.7272 13.1364V12.1053C7.4146 11.8702 7.21205 11.4962 7.21205 11.0758C7.21205 10.3656 7.78979 9.78788 8.49993 9.78788C9.21006 9.78788 9.7878 10.3656 9.7878 11.0758C9.7878 11.4962 9.58525 11.8702 9.27265 12.1053ZM5.66659 4.37879C5.66659 2.81649 6.93763 1.54545 8.49993 1.54545C10.0622 1.54545 11.3333 2.81649 11.3333 4.37879V6.69697H5.66659V4.37879Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19479_3267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.1e273d9bea639ae5ac2198528100bd41.svg";
export { ForwardRef as ReactComponent };